import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContactImage from "../assets/personal/summit_extra/se9.jpg";
import Footer from "../components/homepage/Footer";

export default function Contact() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataEncoded = new URLSearchParams();
    formDataEncoded.append("form-name", "contact");

    Object.keys(formData).forEach((key) => {
      formDataEncoded.append(key, formData[key]);
    });

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formDataEncoded.toString(),
      });

      navigate("/contact-confirmation", { state: formData });

      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Form submission error:", error);
    }
  };

  return (
    <div className="min-h-screen w-full pt-24 px-4 md:px-10 flex flex-col items-center">
      <div
        className="w-full max-w-6xl flex flex-col lg:flex-row items-center
                   bg-black/50 backdrop-blur-lg p-8 lg:p-10 rounded-2xl gap-10
                   border border-gray-200 shadow-xl"
      >
        {/* Image section */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={ContactImage}
            alt="Contact"
            className="w-full h-auto rounded-xl shadow-lg
                       transition-transform duration-500 hover:scale-[1.03]"
          />
        </div>

        {/* Form section */}
        <div className="w-full lg:w-1/2">
          <h2 className="text-white text-4xl md:text-5xl font-bold mb-8 text-center lg:text-left">
            Contact Us
          </h2>

          <form
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className="space-y-6"
          >
            {/* Required hidden input for Netlify */}
            <input type="hidden" name="form-name" value="contact" />

            <div>
              <label className="block text-gray-300 mb-2 text-sm font-medium">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                required
                minLength={3}
                maxLength={50}
                placeholder="Your full name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-black/20 border border-gray-500 
                           text-white placeholder-gray-400
                           focus:border-neonTurquoise focus:ring-1 focus:ring-neonTurquoise 
                           outline-none transition"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 text-sm font-medium">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                placeholder="example@email.com"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-black/20 border border-gray-500 
                           text-white placeholder-gray-400
                           focus:border-neonTurquoise focus:ring-1 focus:ring-neonTurquoise 
                           outline-none transition"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 text-sm font-medium">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                required
                rows="6"
                minLength={10}
                maxLength={1000}
                placeholder="Write your message here..."
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-black/20 border border-gray-500 
                           text-white placeholder-gray-400 resize-none
                           focus:border-neonTurquoise focus:ring-1 focus:ring-neonTurquoise 
                           outline-none transition"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-neonTurquoise text-white font-bold py-3 rounded-lg
                         transition-transform duration-300 hover:scale-[1.04]"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}

